import React from "react";
import { useSelector } from "react-redux";

import ReactDatePicker from "../../../../../components/reactDatePicker/reactDatePicker";

const DatePicker = () => {
  const {
    date,
    currentUser: { calendarStartDate, calendarEndDate }
  } = useSelector((state) => state.RiskMembers);

  return (
    <ReactDatePicker
      calendarEndDate={calendarEndDate}
      disabled={true}
      minDate={calendarStartDate}
      startDate={date ? date : calendarEndDate}
    />
  );
};

export default DatePicker;
